<ion-header [translucent]="true">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="goBack()">
        <ion-icon slot="icon-only" name="chevron-back"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>{{ 'Statistics_Tab_Name' | translate }}</ion-title>
    @if (isLoading()) {
      <ion-progress-bar type="indeterminate"></ion-progress-bar>
    }
  </ion-toolbar>
</ion-header>

<ion-content [fullscreen]="true">
  <ion-refresher slot="fixed" (ionRefresh)="handleRefresh($event)">
    <ion-refresher-content></ion-refresher-content>
  </ion-refresher>

  <div class="content-wrapper">

    @if (!!statistics().length) {
      <div class="statistic-wrapper" [class.slide]="!!statistics().length">
        @for (statistic of statistics(); track statistic.id || $index) {
          <div class="statistic-card">
            <div class="content">
              <div class="content-wrapper">
                <div class="title">
                  <div class="left-side">
                    <h4 class="name">{{ statistic.title }}</h4>
                  </div>
                  <div class="right-side">
                    <p class="date">{{ statistic.createdAt | date: 'dd.MM.yyyy' }}</p>
                  </div>
                </div>
                <div class="message-preview">
                  <div class="value-unit">
                    <span class="background-color" [style.backgroundColor]="statistic.color"></span>
                    <h1 class="value" [style.color]="statistic.color">{{ statistic.value }}</h1>
                    <h4 class="unit" [style.color]="statistic.color">{{ statistic.unit }}</h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    }

    @if (!isLoading() && !statistics().length) {
      <h2 class="no-items">
        <ion-icon name="mail-open-outline"></ion-icon>
        {{ 'No_statistics' | translate}}
      </h2>
    }

  </div>
</ion-content>